var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-295.3 562.7 679.8 679.8",
    enableBackground: "new -295.3 562.7 679.8 679.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.2,1242.5h-304.9c-37.2,0-71.7-14-97.2-39.5s-39.5-60-39.5-97.2V1072c0-19.3,15.7-35,35-35h32.8V699.3 c0-37.2,14-71.7,39.5-97.2s60-39.5,97.2-39.5h372.6c56.7,0,102.8,46.1,102.8,102.8s-46.1,102.8-102.8,102.8H249v371.5 C249,1196.4,202.9,1242.5,146.2,1242.5z M-157.5,1037h236c19.3,0,35,15.7,35,35v67.8c0,18.1,14.7,32.8,32.8,32.8 s32.8-14.7,32.8-32.8V665.5c0-11.4,1.9-22.5,5.4-32.8H-90.9c-38,0-66.6,28.6-66.6,66.6V1037z M-225.3,1107 c0.6,37.4,29,65.5,66.6,65.5H48.8c-3.5-10.3-5.4-21.3-5.4-32.8V1107H-225.3z M249,698.2h32.8c18.1,0,32.8-14.7,32.8-32.8 s-14.7-32.8-32.8-32.8c-18.1,0-32.8,14.7-32.8,32.8V698.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5,768.2H-57c-19.3,0-35-15.7-35-35s15.7-35,35-35H78.5c19.3,0,35,15.7,35,35S97.8,768.2,78.5,768.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5,903.7H-57c-19.3,0-35-15.7-35-35s15.7-35,35-35H78.5c19.3,0,35,15.7,35,35S97.8,903.7,78.5,903.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.8ac9bf83.svg";
export { ForwardRef as ReactComponent };